import { Resources } from '@app/resources';

export default {
  path: Resources.SettingsCompanyDetails,
  loadComponent: () => import('./company-details.component').then(c=> c.CompanyDetailsComponent),
  children: [
    {
      path: Resources.SettingsCompanyGroupCompanies,
      loadComponent: () => import('./pages/company-group-companies/company-group-companies.component').then(c => c.CompanyGroupCompaniesComponent),
    },
    {
      path: Resources.SettingsCompanyUsers,
      loadComponent: () => import('./pages/company-users/company-users.component').then(c => c.CompanyUsersComponent),
    },
    {
      path: Resources.SettingsCompanyProperties,
      loadComponent: () => import('./pages/company-properties/company-properties.component').then(c => c.CompanyPropertiesComponent),
    },
    {
      path: Resources.SettingsCompanyApartments,
      loadComponent: () => import('./pages/company-apartments/company-apartments.component').then(c => c.CompanyApartmentsComponent),
    },
    {
      path: '',
      redirectTo: 'users',
      pathMatch: 'full'
    },
  ]
}
